"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _styled = require("../styled");
var _memoizeOne = _interopRequireDefault(require("../helpers/memoizeOne"));
var _isShallowEqual = _interopRequireDefault(require("../helpers/isShallowEqual"));
var _templateObject, _templateObject2, _templateObject3;
var getSortedKeys = function getSortedKeys(obj) {
  return Object.keys(obj).sort(function (a, b) {
    return obj[a] - obj[b];
  });
};
var createMinQueries = function createMinQueries(keys, obj, opts) {
  return keys.reduce(function (acc, key) {
    if (key !== opts.minKey) {
      var bp = obj[key];
      acc[key] = function () {
        return (0, _styled.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n        @media (min-width: ", "px) {\n          ", ";\n        }\n      "])), bp, _styled.css.apply(void 0, arguments));
      };
    }
    return acc;
  }, {});
};
var createMaxQueries = function createMaxQueries(keys, obj, opts) {
  return keys.reduce(function (acc, key, index) {
    if (key !== opts.maxKey) {
      var nextKey = keys[index + 1];
      var bp = obj[nextKey] - 1;
      acc[key] = function () {
        return (0, _styled.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n        @media (max-width: ", "px) {\n          ", ";\n        }\n      "])), bp, _styled.css.apply(void 0, arguments));
      };
    }
    return acc;
  }, {});
};
var createOnlyQueries = function createOnlyQueries(keys, obj, opts) {
  return keys.reduce(function (acc, key, index) {
    if (key === opts.minKey) {
      acc[key] = opts.maxQueries[key];
    } else if (key === opts.maxKey) {
      acc[key] = opts.minQueries[key];
    } else {
      var minBp = obj[key];
      var nextKey = keys[index + 1];
      var maxBp = obj[nextKey] - 1;
      acc[key] = function () {
        return (0, _styled.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n        @media (min-width: ", "px) and (max-width: ", "px) {\n          ", ";\n        }\n      "])), minBp, maxBp, _styled.css.apply(void 0, arguments));
      };
    }
    return acc;
  }, {});
};
var createMediaQueries = (0, _memoizeOne.default)(function (bps) {
  var keys = getSortedKeys(bps);
  var minKey = keys[0];
  var maxKey = keys[keys.length - 1];
  var minQueries = createMinQueries(keys, bps, {
    minKey: minKey
  });
  var maxQueries = createMaxQueries(keys, bps, {
    maxKey: maxKey
  });
  var onlyQueries = createOnlyQueries(keys, bps, {
    minKey: minKey,
    minQueries: minQueries,
    maxKey: maxKey,
    maxQueries: maxQueries
  });
  return {
    keys: keys,
    min: minQueries,
    max: maxQueries,
    only: onlyQueries
  };
}, _isShallowEqual.default);
var _default = exports.default = createMediaQueries;